<template>
  <p
    class="mb-0 "
    :class="{'pull-right': message.userId === user.id}"
  >
    <span v-if="message.type==='TEXT'">{{ message.messageText }}</span>
    <img
      v-else-if="message.type==='PHOTO' && isPhoto"
      :src="`${mediaBase}/medium${messageData.path}`"
      class="w-100"
      :alt="$t('conversationMessage.attachment')"
    >
    <a
      v-else-if="message.type==='PHOTO' && !isPhoto"
      :href="`${mediaBase}${messageData.path}`"
      target="_blank"
      class="btn btn-outline-primary"
    >
      {{ $t('conversationMessage.faylYklyin', {pop: messageData.path.split('.').pop()}) }}
    </a>
    <span v-else-if="message.type==='CONTACT'">
      <strong>{{ messageData.name }}</strong> <br>
      <em>{{ messageData.phone }}</em>
    </span>
    <br>
    <span class="text-secondary small">{{ getMoment(message.logTime) }}</span>
  </p>
</template>
<script>
import {mapState} from "vuex";
import {mediaBase} from "@/repositories/Repository";
import {getPhoto} from "@/repositories/Utils";
import moment from "moment/moment";

export default {
  name: 'ConversationMessage',
  props: {
    message: {},
  },
  data() {
    return {
      mediaBase: mediaBase
    }
  },
  computed: {
    ...mapState({
      token: state => state.auth.token,
      user: state => state.auth.user,
    }),

    messageData() {
      if (this.message.messageData) {
        return JSON.parse(this.message.messageData)
      } else {
        return {};
      }
    },

    isPhoto() {
      if (this.messageData.path) {
        return ['jpg', 'png', 'gif', 'jpeg'].indexOf(this.messageData.path.toLowerCase().split('.').pop()) > -1;
      } else {
        return false;
      }
    },

  },
  methods: {
    getMoment(time) {
      moment.locale(this.$i18n.locale);
      return moment(new Date(time)).format('DD MMM YYYY HH:mm')
    },
    getPhoto(path, size) {
      return getPhoto(path, size);
    },
  }
}
</script>
